module.exports = __webpack_public_path__ + "img/2258@2x.b914929e.png";